export enum BreakInPlatAttribute {
  Rain = 635,
  Injury = 636,
  BadLight = 637,
  Drinks = 638,
  TacticalTimeout = 639,
  Other = 640,
}
